import React, { ReactNode } from 'react';

import Shimmer from 'components/Shimmer';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { DetailsSlideDown, Content, Row, ToggleDetails, PolicyStatus, DropdownChevron } from './styles';

type Props = {
  open: boolean;
  children: ReactNode;
  onToggle: (open: boolean) => void;
  outOfPolicy: boolean;
  isLoading?: boolean;
  breakRulesReasonMessage?: string;
};

const Details = ({ open, children, onToggle, outOfPolicy, isLoading, breakRulesReasonMessage }: Props) => {
  const { t } = useStoreTranslation();

  if (isLoading)
    return (
      <Row>
        <PolicyStatus $valid={true}>
          <Shimmer>Within policies</Shimmer>
        </PolicyStatus>
        <ToggleDetails $detailsOpen={false}>
          <Shimmer>more details</Shimmer>
        </ToggleDetails>
      </Row>
    );
  return (
    <>
      <Row>
        {!open && (
          <PolicyStatus $valid={!outOfPolicy}>
            {outOfPolicy ? t('requestCard.details.policyStatus.invalid') : t('requestCard.details.policyStatus.valid')}
          </PolicyStatus>
        )}
        <ToggleDetails onClick={() => onToggle(!open)} $detailsOpen={open}>
          {open ? t('requestCard.details.lessDetails') : t('requestCard.details.moreDetails')}
          <DropdownChevron />
        </ToggleDetails>
      </Row>

      <DetailsSlideDown transitionOnAppear={false} closed={!open}>
        <Content>{children}</Content>
      </DetailsSlideDown>
    </>
  );
};

export default Details;
